
import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';


import AdminLayout from "../../components/Layout/AdminLayout/AdminLayout";

import { GetAdmin, RequestUpdateAdmin } from '../../interface/IAdminRegistry';
import helpers from '../../helpers/index';

import adminRegistryService from './adminRegistryService';

import SuccessModal from '../../components/Modal/SuccessModal';



function UpdateAdmin() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [requestUpdateAdmin, setRequestUpdateAdmin] = useState<RequestUpdateAdmin>({
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        permission: '',
    });

    const { username } = useParams<{ username: string; }>();

    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);

    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    async function GetAdmin() {
        try {

            var adminDetail = await adminRegistryService.getAdmin(username);

            var result: GetAdmin = adminDetail.data.result;

            setRequestUpdateAdmin({
                firstname: result.firstname,
                lastname: result.lastname,
                middlename: result.middlename,
                email: result.email,
                permission: result.permission
            });



        }
        catch (error) {
            console.log('GetAdmin error:: ', error);
        }
    }

    async function CancelButtonClick() {
        navigate('/Admin/AdminRegistry');
    }

    async function UpdateButtonClick() {

        try {
            document.querySelector('.loader-container')?.classList.add('loader');
            await adminRegistryService.updateAdminRegistry(username, {
                firstname: requestUpdateAdmin?.firstname,
                lastname: requestUpdateAdmin?.lastname,
                middlename: requestUpdateAdmin?.middlename,
                email: requestUpdateAdmin?.email,
                permission: requestUpdateAdmin?.permission
            });

            openModal();
            // navigate('/AdminRegistry');
        }
        catch (error) {
            console.log('error:: ', error);
        }
        finally {

            document.querySelector('.loader-container')?.classList.remove('loader');
        }


    }




    const openModal = () => {
        setModalOpen(true);
    };

    const onClose = () => {
        setModalOpen(false);
        navigate('/Admin/AdminRegistry');
    };

    useEffect(() => {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await GetAdmin();
            getPermission();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <AdminLayout>

            <div>
                <SuccessModal message="Update Successful." isOpen={isModalOpen} onClose={onClose} />
            </div>
            <div className="title-container">
                <div className="dv-title">
                    <h1>Edit Permission</h1>

                </div>
                <div className="title-btn-container vertical-flex-bottom">

                    <button type="button" id="btnCancel"
                        onClick={CancelButtonClick}
                        className="btn-white-green-2 center-middle">Cancel</button>
                    &nbsp;
                    <button type="button" id="btnUpdate" disabled={isReadOnly}
                        onClick={UpdateButtonClick}
                        className="btn-green-2 center-middle">Update</button>

                </div>
            </div>
            <br />
            <div className='content-container'>
                <div className='padding-container'>
                    <div className='title'>
                        Admin Info
                    </div>
                    <div>

                        <div className='label-1'>
                            First name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2" name="firstname" id="txtFirstname" placeholder="Enter First Name"
                                value={requestUpdateAdmin?.firstname}
                                onChange={(event) =>
                                    setRequestUpdateAdmin((prevState) => ({
                                        ...prevState,
                                        firstname: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Middle name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2" name="middlename" id="txtMiddlename" placeholder="Enter Middle Name"
                                value={requestUpdateAdmin?.middlename}
                                onChange={(event) =>
                                    setRequestUpdateAdmin((prevState) => ({
                                        ...prevState,
                                        middlename: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Last name:
                        </div>
                        <div>
                            <input disabled={isReadOnly} type="text" className="textbox-green-2" name="lastname" id="txtLastname" placeholder="Enter Last Name"
                                value={requestUpdateAdmin?.lastname}
                                onChange={(event) =>
                                    setRequestUpdateAdmin((prevState) => ({
                                        ...prevState,
                                        lastname: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Username
                        </div>
                        <div>
                            <input type="text" className="textbox-green-2" name="username" id="txtUsername" placeholder="Enter Username"
                                disabled={isDisabled}
                                value={username}
                            />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>

                        <div className='label-1'>
                            Email
                        </div>
                        <div>
                            <input type="text" className="textbox-green-2" name="email" id="txtEmail" placeholder="eg. koopmember@koop.com"
                                disabled={isReadOnly}
                                value={requestUpdateAdmin?.email}
                                onChange={(event) =>
                                    setRequestUpdateAdmin((prevState) => ({
                                        ...prevState,
                                        email: event.target.value,
                                    }))
                                } />

                        </div>
                        <div>
                            <label className='label-error-1'> </label>
                        </div>
                    </div>
                    <div>
                        <div className="title">
                            Permission
                        </div>
                        <div className='label-1'>
                            Please select a permission type
                        </div>
                        <div>
                            <div className='content-container-4'>
                                <div>
                                    <label>
                                        <input type="radio" name="permission" value="ReadOnly"
                                            disabled={isReadOnly}
                                            checked={requestUpdateAdmin?.permission === "ReadOnly"}
                                            onChange={(e) =>
                                                setRequestUpdateAdmin({
                                                    ...requestUpdateAdmin,
                                                    permission: e.target.value,
                                                })
                                            }
                                        /> Read Only

                                    </label>
                                </div>
                                <div>

                                    <label>
                                        <input type="radio" name="permission" value="ReadAndWrite"
                                            disabled={isReadOnly}
                                            checked={requestUpdateAdmin?.permission === "ReadAndWrite"}
                                            onChange={(e) =>
                                                setRequestUpdateAdmin({
                                                    ...requestUpdateAdmin,
                                                    permission: e.target.value,
                                                })
                                            }
                                        /> Read and Write
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </AdminLayout>

    );
}

export default UpdateAdmin;